import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CookieService} from './cookie.service'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class DataWorkerModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DataWorkerModule,
      providers: [
        CookieService
      ]
    };
  }


 }



// WEBPACK FOOTER //
// ./src/app/data-worker/data-worker.module.ts